module.exports = __webpack_public_path__ + "static/media/contacts.3930fd76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/contacts.svg
// module id = 2150
// module chunks = 0